import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './config';

/**
 * QueuePaymentForPrintingView answers its own business-rule refusals with HTTP
 * 200 and `status: 'error'`, so callers have to read the body rather than trust
 * a resolved promise. Every branch of that view sets `status`; only the refusal
 * branches carry a `message`, which is why that one is optional.
 */
export type QueueReceiptResponse = {
  status: 'success' | 'error';
  message?: string;
};

/**
 * PrinterStatusView: the printers whose connector has polled or registered
 * within the registry's 5-minute cache TTL.
 */
export type Printer = {
  id: string;
  displayName: string;
  lastSeen: string | null;
};

export type PrintersResponse = {
  data: Printer[];
};

export function savePrinterSelection(printerId: string) {
  // Save the selected printer to local storage
  localStorage.setItem('selectedPrinter', printerId);
}

export const printingApi = createApi({
  reducerPath: 'printings',
  baseQuery,
  endpoints: builder => ({
    getPrinterKeys: builder.mutation({
      query: () => `/printer/config`,
    }),
    queuePaymentReceipt: builder.mutation<QueueReceiptResponse, number>({
      query: paymentId => ({
        url: `/printer/queue-payment/${paymentId}`,
        method: 'POST',
      }),
    }),
    getPrinters: builder.query<PrintersResponse, object>({
      query: () => `/printer/list`,
    }),
  }),
});

const {
  useGetPrinterKeysMutation,
  useQueuePaymentReceiptMutation,
  useGetPrintersQuery,
} = printingApi;
export {
  useGetPrinterKeysMutation,
  useQueuePaymentReceiptMutation,
  useGetPrintersQuery,
};
